import { defineComponent, openBlock, createElementBlock, renderSlot } from "vue";
import _export_sfc from "../_virtual/plugin-vue_export-helper";
const _sfc_main = defineComponent({
  name: "Tbody"
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("tbody", null, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
var _Tbody = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { _Tbody as default };
